export default {
    slug: 'plaid',
    ability: 'plaid',
    routes: [],
    integrationRoutes: [
        {
            path: 'plaid',
            name: 'settings-plaid',
            component: () => import('@modules/SyncPlaid/Resources/js/pages/PlaidSettings.vue'),
            meta: { label: 'Plaid' }
        }
    ],
    integrationTabs: () => [
        {
            title: i18n.t('Plaid'),
            icon: 'bank',
            route: 'settings-plaid',
            position: 30
        }
    ]
};
